// src/components/dashboard/cases/newCase/case_id/caseTable/components/Sidebar.js
import React from "react";
import { OPACITY_MAX } from "../constants";

const Sidebar = ({
  goTo,
  wireframe,
  setWireframe,
  showOpacity,
  setShowOpacity,
  autoRotate,
  setAutoRotate,
  showCrossSection,
  sectionDrawMode,
  handleSectionButton,
  measureMode,
  setMeasureMode,
  expanded,
  toggleSidebar,
  hasActiveDisplay,
  opacity,
  dockClass,
  dockRef,
  onDockPointerDown,
}) => {
  return (
    <div
      ref={dockRef}
      className={dockClass}
      onPointerDown={onDockPointerDown}
      onContextMenu={(e) => e.preventDefault()}
    >
      <aside className="stl-sidebar" aria-label="Viewer controls">
        <div className="stl-sidebar-section">
          <span className="stl-sidebar-label">View</span>
          <div className="stl-sidebar-group">
            <button className="stl-sidebar-btn" onClick={() => goTo("default")}
              title="Reset view" aria-label="Reset view">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 12a9 9 0 1 0 3-6.7" />
                <path d="M3 4v5h5" />
              </svg>
              <span>Reset</span>
            </button>
            <button className="stl-sidebar-btn" onClick={() => goTo("top")}
              title="Top view" aria-label="Top view">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <path d="M4 9h16" />
              </svg>
              <span>Top</span>
            </button>
            <button className="stl-sidebar-btn" onClick={() => goTo("bottom")}
              title="Bottom view" aria-label="Bottom view">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <path d="M4 15h16" />
              </svg>
              <span>Bottom</span>
            </button>
            <button className="stl-sidebar-btn" onClick={() => goTo("front")}
              title="Front view" aria-label="Front view">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="4" y="6" width="16" height="12" rx="2" />
              </svg>
              <span>Front</span>
            </button>
            <button className="stl-sidebar-btn" onClick={() => goTo("rear")}
              title="Rear view" aria-label="Rear view">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="4" y="6" width="16" height="12" rx="2" />
                <path d="M8 10h8" />
              </svg>
              <span>Rear</span>
            </button>
            <button className="stl-sidebar-btn" onClick={() => goTo("left")}
              title="Left view" aria-label="Left view">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M7 4h10v16H7z" />
                <path d="M11 8h4" />
              </svg>
              <span>Left</span>
            </button>
            <button className="stl-sidebar-btn" onClick={() => goTo("right")}
              title="Right view" aria-label="Right view">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M7 4h10v16H7z" />
                <path d="M9 8h4" />
              </svg>
              <span>Right</span>
            </button>
          </div>
        </div>

        <div
          id="stl-sidebar-more"
          className={`stl-sidebar-collapsible${expanded ? " open" : ""}`}
          aria-hidden={!expanded}
        >
          <div className="stl-sidebar-collapsible-inner">
            <div className="stl-sidebar-collapsible-content">
              <div className="stl-sidebar-divider" />
              <div className="stl-sidebar-section">
                <span className="stl-sidebar-label">Display</span>
                <div className="stl-sidebar-group">
                  <button
                    className={`stl-sidebar-btn${wireframe ? " active" : ""}`}
                    onClick={() => setWireframe((v) => !v)}
                    title="Toggle wireframe"
                    aria-label="Toggle wireframe"
                    aria-pressed={wireframe}
                    tabIndex={expanded ? 0 : -1}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 2 2 7l10 5 10-5-10-5z" />
                      <path d="m2 17 10 5 10-5" />
                      <path d="m2 12 10 5 10-5" />
                    </svg>
                    <span>Wireframe</span>
                  </button>
                  <button
                    className={`stl-sidebar-btn${
                      showOpacity || opacity < OPACITY_MAX ? " active" : ""
                    }`}
                    onClick={() => setShowOpacity((v) => !v)}
                    title="Opacity (see-through)"
                    aria-label="Opacity (see-through)"
                    aria-pressed={showOpacity}
                    aria-expanded={showOpacity}
                    tabIndex={expanded ? 0 : -1}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="9" />
                      <path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor" stroke="none" />
                    </svg>
                    <span>Opacity</span>
                  </button>
                  <button
                    className={`stl-sidebar-btn${autoRotate ? " active" : ""}`}
                    onClick={() => setAutoRotate((v) => !v)}
                    title="Toggle auto-rotate"
                    aria-label="Toggle auto-rotate"
                    aria-pressed={autoRotate}
                    tabIndex={expanded ? 0 : -1}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 12a9 9 0 1 1-3-6.7" />
                      <path d="M21 3v5h-5" />
                    </svg>
                    <span>Auto-rotate</span>
                  </button>
                  <button
                    className={`stl-sidebar-btn${showCrossSection || sectionDrawMode ? " active" : ""}`}
                    onClick={handleSectionButton}
                    title="Draw a line on the model to open 2D cross section"
                    aria-label="2D cross section"
                    aria-pressed={showCrossSection || sectionDrawMode}
                    tabIndex={expanded ? 0 : -1}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 6h18" />
                      <path d="M3 12h18" />
                      <path d="M3 18h18" />
                      <circle cx="9" cy="12" r="3" fill="currentColor" stroke="none" opacity="0.7" />
                    </svg>
                    <span>Section</span>
                  </button>
                  <button
                    className={`stl-sidebar-btn${measureMode ? " active" : ""}`}
                    onClick={() => setMeasureMode((v) => !v)}
                    title="Measure distance"
                    aria-label="Measure distance"
                    aria-pressed={measureMode}
                    tabIndex={expanded ? 0 : -1}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21.3 8.7 8.7 21.3a1 1 0 0 1-1.4 0l-4.6-4.6a1 1 0 0 1 0-1.4L15.3 2.7a1 1 0 0 1 1.4 0l4.6 4.6a1 1 0 0 1 0 1.4z" />
                      <path d="m7.5 10.5 2 2" />
                      <path d="m10.5 7.5 2 2" />
                      <path d="m13.5 4.5 2 2" />
                      <path d="m4.5 13.5 2 2" />
                    </svg>
                    <span>Measure</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          className={`stl-sidebar-toggle${expanded ? " expanded" : ""}${
            !expanded && (hasActiveDisplay || showCrossSection || measureMode || sectionDrawMode)
              ? " has-active" : ""
          }`}
          onClick={toggleSidebar}
          title={expanded ? "Show fewer controls" : "Show more controls"}
          aria-label={expanded ? "Show fewer controls" : "Show more controls"}
          aria-expanded={expanded}
          aria-controls="stl-sidebar-more"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </aside>
    </div>
  );
};

export default Sidebar;